/**
 * Match an appliance model number against a comma-separated pattern list.
 * Patterns are matched case-insensitively as prefix/substring tokens.
 * `*` is treated as a wildcard.
 * If pattern is empty/null → matches all models for the brand+type.
 */
export function modelMatches(modelNumber: string | null | undefined, pattern: string | null | undefined): boolean {
  if (!pattern || !pattern.trim()) return true;
  if (!modelNumber) return false;
  const m = modelNumber.toUpperCase().trim();
  return pattern
    .split(",")
    .map((p) => p.trim().toUpperCase())
    .filter(Boolean)
    .some((p) => {
      if (p.includes("*")) {
        const re = new RegExp("^" + p.replace(/[.+?^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*") + "$");
        return re.test(m);
      }
      return m.includes(p);
    });
}
